"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Mode = void 0;

var _EventType = _interopRequireDefault(require("../events/EventType.js"));

var _Interaction = _interopRequireWildcard(require("./Interaction.js"));

var _has = require("../has.js");

var _condition = require("../events/condition.js");

var _math = require("../math.js");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/interaction/MouseWheelZoom
 */


/**
 * @enum {string}
 */
var Mode = {
  TRACKPAD: 'trackpad',
  WHEEL: 'wheel'
};
/**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled. Default is
 * {@link module:ol/events/condition.always}.
 * @property {boolean} [onFocusOnly=false] When the map's target has a `tabindex` attribute set,
 * the interaction will only handle events when the map has the focus.
 * @property {number} [maxDelta=1] Maximum mouse wheel delta.
 * @property {number} [duration=250] Animation duration in milliseconds.
 * @property {number} [timeout=80] Mouse wheel timeout duration in milliseconds.
 * @property {boolean} [useAnchor=true] Enable zooming using the mouse's
 * location as the anchor. When set to `false`, zooming in and out will zoom to
 * the center of the screen instead of zooming on the mouse's location.
 * @property {boolean} [constrainResolution=false] If true, the mouse wheel zoom
 * event will always animate to the closest zoom level after an interaction;
 * false means intermediary zoom levels are allowed.
 */

/**
 * @classdesc
 * Allows the user to zoom the map by scrolling the mouse wheel.
 * @api
 */

exports.Mode = Mode;

var MouseWheelZoom =
/** @class */
function (_super) {
  __extends(MouseWheelZoom, _super);
  /**
   * @param {Options} [opt_options] Options.
   */


  function MouseWheelZoom(opt_options) {
    var _this = this;

    var options = opt_options ? opt_options : {};
    _this = _super.call(this,
    /** @type {import("./Interaction.js").InteractionOptions} */
    options) || this;
    /**
     * @private
     * @type {number}
     */

    _this.totalDelta_ = 0;
    /**
     * @private
     * @type {number}
     */

    _this.lastDelta_ = 0;
    /**
     * @private
     * @type {number}
     */

    _this.maxDelta_ = options.maxDelta !== undefined ? options.maxDelta : 1;
    /**
     * @private
     * @type {number}
     */

    _this.duration_ = options.duration !== undefined ? options.duration : 250;
    /**
     * @private
     * @type {number}
     */

    _this.timeout_ = options.timeout !== undefined ? options.timeout : 80;
    /**
     * @private
     * @type {boolean}
     */

    _this.useAnchor_ = options.useAnchor !== undefined ? options.useAnchor : true;
    /**
     * @private
     * @type {boolean}
     */

    _this.constrainResolution_ = options.constrainResolution !== undefined ? options.constrainResolution : false;
    var condition = options.condition ? options.condition : _condition.always;
    /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */

    _this.condition_ = options.onFocusOnly ? (0, _condition.all)(_condition.focusWithTabindex, condition) : condition;
    /**
     * @private
     * @type {?import("../coordinate.js").Coordinate}
     */

    _this.lastAnchor_ = null;
    /**
     * @private
     * @type {number|undefined}
     */

    _this.startTime_ = undefined;
    /**
     * @private
     * @type {?}
     */

    _this.timeoutId_;
    /**
     * @private
     * @type {Mode|undefined}
     */

    _this.mode_ = undefined;
    /**
     * Trackpad events separated by this delay will be considered separate
     * interactions.
     * @type {number}
     */

    _this.trackpadEventGap_ = 400;
    /**
     * @type {?}
     */

    _this.trackpadTimeoutId_;
    /**
     * The number of delta values per zoom level
     * @private
     * @type {number}
     */

    _this.deltaPerZoom_ = 300;
    return _this;
  }
  /**
   * @private
   */


  MouseWheelZoom.prototype.endInteraction_ = function () {
    this.trackpadTimeoutId_ = undefined;
    var view = this.getMap().getView();
    view.endInteraction(undefined, this.lastDelta_ ? this.lastDelta_ > 0 ? 1 : -1 : 0, this.lastAnchor_);
  };
  /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} (if it was a mousewheel-event) and eventually
   * zooms the map.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   */


  MouseWheelZoom.prototype.handleEvent = function (mapBrowserEvent) {
    if (!this.condition_(mapBrowserEvent)) {
      return true;
    }

    var type = mapBrowserEvent.type;

    if (type !== _EventType["default"].WHEEL) {
      return true;
    }

    var map = mapBrowserEvent.map;
    var wheelEvent =
    /** @type {WheelEvent} */
    mapBrowserEvent.originalEvent;
    wheelEvent.preventDefault();

    if (this.useAnchor_) {
      this.lastAnchor_ = mapBrowserEvent.coordinate;
    } // Delta normalisation inspired by
    // https://github.com/mapbox/mapbox-gl-js/blob/001c7b9/js/ui/handler/scroll_zoom.js


    var delta;

    if (mapBrowserEvent.type == _EventType["default"].WHEEL) {
      delta = wheelEvent.deltaY;

      if (_has.FIREFOX && wheelEvent.deltaMode === WheelEvent.DOM_DELTA_PIXEL) {
        delta /= _has.DEVICE_PIXEL_RATIO;
      }

      if (wheelEvent.deltaMode === WheelEvent.DOM_DELTA_LINE) {
        delta *= 40;
      }
    }

    if (delta === 0) {
      return false;
    } else {
      this.lastDelta_ = delta;
    }

    var now = Date.now();

    if (this.startTime_ === undefined) {
      this.startTime_ = now;
    }

    if (!this.mode_ || now - this.startTime_ > this.trackpadEventGap_) {
      this.mode_ = Math.abs(delta) < 4 ? Mode.TRACKPAD : Mode.WHEEL;
    }

    var view = map.getView();

    if (this.mode_ === Mode.TRACKPAD && !(view.getConstrainResolution() || this.constrainResolution_)) {
      if (this.trackpadTimeoutId_) {
        clearTimeout(this.trackpadTimeoutId_);
      } else {
        if (view.getAnimating()) {
          view.cancelAnimations();
        }

        view.beginInteraction();
      }

      this.trackpadTimeoutId_ = setTimeout(this.endInteraction_.bind(this), this.timeout_);
      view.adjustZoom(-delta / this.deltaPerZoom_, this.lastAnchor_);
      this.startTime_ = now;
      return false;
    }

    this.totalDelta_ += delta;
    var timeLeft = Math.max(this.timeout_ - (now - this.startTime_), 0);
    clearTimeout(this.timeoutId_);
    this.timeoutId_ = setTimeout(this.handleWheelZoom_.bind(this, map), timeLeft);
    return false;
  };
  /**
   * @private
   * @param {import("../PluggableMap.js").default} map Map.
   */


  MouseWheelZoom.prototype.handleWheelZoom_ = function (map) {
    var view = map.getView();

    if (view.getAnimating()) {
      view.cancelAnimations();
    }

    var delta = -(0, _math.clamp)(this.totalDelta_, -this.maxDelta_ * this.deltaPerZoom_, this.maxDelta_ * this.deltaPerZoom_) / this.deltaPerZoom_;

    if (view.getConstrainResolution() || this.constrainResolution_) {
      // view has a zoom constraint, zoom by 1
      delta = delta ? delta > 0 ? 1 : -1 : 0;
    }

    (0, _Interaction.zoomByDelta)(view, delta, this.lastAnchor_, this.duration_);
    this.mode_ = undefined;
    this.totalDelta_ = 0;
    this.lastAnchor_ = null;
    this.startTime_ = undefined;
    this.timeoutId_ = undefined;
  };
  /**
   * Enable or disable using the mouse's location as an anchor when zooming
   * @param {boolean} useAnchor true to zoom to the mouse's location, false
   * to zoom to the center of the map
   * @api
   */


  MouseWheelZoom.prototype.setMouseAnchor = function (useAnchor) {
    this.useAnchor_ = useAnchor;

    if (!useAnchor) {
      this.lastAnchor_ = null;
    }
  };

  return MouseWheelZoom;
}(_Interaction["default"]);

var _default = MouseWheelZoom;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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